import {
  AboutUs,
  type AboutUsCopy,
} from "@components/bluetooth-landing/AboutUs";
import {
  BluetoothPageMetadata,
  type BluetoothPageMetadataProps,
} from "@components/bluetooth-landing/BluetoothPageMetadata";
import { ClientToaster } from "@components/bluetooth-landing/ClientToaster";
import { FAQ, type FAQCopy } from "@components/bluetooth-landing/FAQ";
import { Footer, type FooterCopy } from "@components/bluetooth-landing/Footer";
import { Hero, type HeroCopy } from "@components/bluetooth-landing/Hero";
import { Navbar, type NavbarCopy } from "@components/bluetooth-landing/Navbar";
import {
  Process,
  type ProcessCopy,
} from "@components/bluetooth-landing/Process";
import {
  Services,
  type ServicesCopy,
} from "@components/bluetooth-landing/Services";
import {
  TargetAudience,
  type TargetAudienceCopy,
} from "@components/bluetooth-landing/TargetAudience";
import {
  ValueProposition,
  type ValuePropositionCopy,
} from "@components/bluetooth-landing/ValueProposition";
import type { LanguageAlternate } from "@data/bluetooth-landing/languageAlternates";

export interface BluetoothLandingPageProps {
  metadata: BluetoothPageMetadataProps;
  alternateLanguage?: LanguageAlternate;
  navbarCopy?: NavbarCopy;
  heroCopy: HeroCopy;
  targetAudienceCopy: TargetAudienceCopy;
  valuePropositionCopy: ValuePropositionCopy;
  servicesCopy: ServicesCopy;
  processCopy: ProcessCopy;
  aboutUsCopy: AboutUsCopy;
  faqCopy: FAQCopy;
  footerCopy: FooterCopy;
}

export function BluetoothLandingPage({
  metadata,
  alternateLanguage,
  navbarCopy,
  heroCopy,
  targetAudienceCopy,
  valuePropositionCopy,
  servicesCopy,
  processCopy,
  aboutUsCopy,
  faqCopy,
  footerCopy,
}: BluetoothLandingPageProps) {
  return (
    <div className="bluetooth-landing">
      <BluetoothPageMetadata {...metadata} />
      <ClientToaster />
      <Navbar copy={navbarCopy} alternateLanguage={alternateLanguage} />
      <main>
        <Hero copy={heroCopy} />
        <TargetAudience copy={targetAudienceCopy} />
        <ValueProposition copy={valuePropositionCopy} />
        <Services copy={servicesCopy} />
        <Process copy={processCopy} />
        <AboutUs copy={aboutUsCopy} />
        <FAQ copy={faqCopy} />
      </main>
      <Footer copy={footerCopy} />
    </div>
  );
}
